import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { patchUser } from 'redux/settings/actions';

import { Checkbox } from 'semantic-ui-react';
import AnalyticsSection from 'components/dashboard/analytics-content/AnalyticsSection';
import TurnOffEarnModal from 'components/dashboard/earn-content/EarnSwitcher/TurnOffEarnModal';
import TurnOnEarnModal from 'components/dashboard/earn-content/EarnSwitcher/TurnOnEarnModal';
import ReviewModal from 'components/dashboard/earn-content/EarnSwitcher/ReviewModal';

import './EarnSwitcher.css';

const EarnSwitcher = ({ me, patchUser }) => {
  const { t } = useTranslation();
  const [earnModalOpen, setEarnModalOpen] = useState(false);
  const [turnOnConfirmModal, setTurnOnConfirmModal] = useState(false);
  const [reviewModal, setReviewModal] = useState(false);

  const checkboxChange = (_e, { checked }) => {
    if (!checked) {
      setEarnModalOpen(true);
    } else if (checked && (me && me.advertise_status.includes('approved'))) {
      const form = new FormData();
      form.append('advertise_enable', !!checked);
      patchUser(form);
    } else {
      setTurnOnConfirmModal(true);
    }
  };

  const onTurnOffEarn = () => {
    const form = new FormData();
    form.append('advertise_enable', false);
    patchUser(form);
    setEarnModalOpen(false);
  };

  const onTurnOnEarn = (countriesList = null) => {
    const form = new FormData();
    form.append('advertise_enable', false);
    if (me && !me.advertise_status.includes('approved')) {
      if (countriesList && countriesList.length > 0) {
        countriesList.forEach(item => (
          form.append('audience_countries_ids', item)
        ));
      }
      setReviewModal(true);
      form.append('advertise_status', 'in_review');
      patchUser(form);
      setTurnOnConfirmModal(false);
    } else {
      patchUser(form);
      setTurnOnConfirmModal(false);
    }
  };

  return (
    <AnalyticsSection
      className={`earn-switcher__component ${me && me.advertise_status.includes('in_review') ? 'hidden' : ''}`}
    >
      <div className="earn-switcher-content">
        <p>{t("Turn on advertising on your HeyLink.me page and start earning money monetising your audience")}</p>

        <div className="switcher-wrapper">
          <span>{t("OFF")}</span>
          <Checkbox
            toggle
            checked={me.advertise_enable || false}
            onChange={checkboxChange}
          />
          <span>{t("ON")}</span>
        </div>
      </div>

      <TurnOffEarnModal
        earnModalOpen={earnModalOpen}
        setEarnModalOpen={setEarnModalOpen}
        onTurnOffEarn={onTurnOffEarn}
      />

      <TurnOnEarnModal
        turnOnConfirmModal={turnOnConfirmModal}
        setTurnOnConfirmModal={setTurnOnConfirmModal}
        onTurnOnEarn={onTurnOnEarn}
      />

      <ReviewModal
        open={reviewModal}
        onClose={() => { setReviewModal(false); }}
      />

    </AnalyticsSection>
  );
};

EarnSwitcher.propTypes = {
  me: PropTypes.object.isRequired,
  patchUser: PropTypes.func,
};
EarnSwitcher.defaultProps = {
  patchUser: null,
};

const mapStateToProps = state => ({
  me: state.usersReducer.me,
});

export default connect(
  mapStateToProps,
  {
    patchUser,
  },
)(EarnSwitcher);
